// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"15":"component---src-pages-cookie-policy-index-js","532":"styles","774":"framework"}[chunkId] + "-" + {"15":"1934583de4377e816953","532":"43c63b01f03cccd988ad","774":"7fba185ab6dd38e2e7c9"}[chunkId] + ".js";
};